require('./runtime');
"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[5553],{

/***/ 4348:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  BaPropTypes
} = _utils.propsUtils;
class CodeSnippet extends _react.Component {
  render() {
    const {
      // remove - remapped
      /* eslint-disable react/prop-types */
      ariaLabel,
      children,
      onClick,
      type,
      wrapText,
      /* eslint-enable react/prop-types */
      // remove - deprecated
      buttonAriaLabel,
      editable,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      height,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      labelFormatter,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onCopy,
      singleLinePaste,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      value,
      width,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // pass all other props to CarbonCodeSnippet
      ...otherCodeSnippetProps
    } = this.props;
    const mappedAriaLabel = ariaLabel != null ? ariaLabel : buttonAriaLabel;
    const mappedChildren = children != null ? children : value;
    const mappedOnClick = onClick != null ? onClick : onCopy;
    const mappedType = type != null ? type : 'multi';
    const mappedWrapText = wrapText != null ? wrapText : true;
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.CodeSnippet, (0, _extends2.default)({}, otherCodeSnippetProps, {
      ariaLabel: mappedAriaLabel,
      onClick: mappedOnClick,
      type: mappedType,
      wrapText: mappedWrapText
    }), mappedChildren);
  }
}
exports["default"] = CodeSnippet;
(0, _defineProperty2.default)(CodeSnippet, "propTypes", {
  /** deprecated - use ariaLabel */
  buttonAriaLabel: BaPropTypes.deprecated('deprecated - use ariaLabel'),
  /** deprecated - not supported in Carbon */
  editable: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - not supported in Carbon */
  height: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - not supported in Carbon */
  labelFormatter: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - use onClick */
  onCopy: BaPropTypes.deprecated('deprecated - use onClick'),
  /** deprecated - not supported in Carbon */
  singleLinePaste: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - send value as children in Carbon */
  value: BaPropTypes.deprecated('deprecated - send value as children in Carbon'),
  /** deprecated - not supported in Carbon */
  width: BaPropTypes.deprecated('deprecated - not supported in Carbon')
});

/***/ }),

/***/ 15952:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _CodeSnippet = _interopRequireDefault(__webpack_require__(4348));
exports["default"] = _CodeSnippet.default;
exports.CodeSnippet = _CodeSnippet.default;

/***/ }),

/***/ 6536:
/***/ ((module) => {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 16689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 78815:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(15952));
/******/ return __webpack_exports__;
/******/ }
]);
});